import { createRequestAtom, createRequestFamily } from '../../../shared/utils/request-atom';
import { Integration, IntegrationDetails } from '../typings';

export const getAllIntegrationsAtom = createRequestAtom<Integration[]>();

export const integrationsAtomFamily = createRequestFamily<
  IntegrationDetails | undefined
>();
